/* eslint-disable */
import React, { useState, useEffect } from 'react';

import {
    Typography,
    Grid,
    Button,
    CircularProgress,
} from '@mui/material'

// hook
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'

import { useSelector, useDispatch } from 'react-redux';

// component
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import TextInputField from '../textInputField';
import ButtonWithLoader from '../buttonWithLoader';

// helper
import { useIsMobileView } from '../../utils/isMobileView';

//  style
import styles from './Support.module.scss'
import { sendMail, getSupportCallStatus, resetStatus } from '../../store/reducers/supportSlice';

import Alert from '../Alert/Alert';
import LoadingSpinner from '../loadingSpinner';

const SupportForm = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    return ()=>{
      dispatch(resetStatus())
    }
  }, [dispatch])

 const [userFields, setUserFields] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
 }) 

 const [validFields, setValidation] = useState({
    firstName: { isValid: false, hasError: false },
    lastName: { isValid: true, hasError: false },
    email: { isValid: false, hasError: false },
    message: { isValid: false, hasError: false },
 })

 const isFormValid = Object.values(validFields).every((field) => field.isValid)

 const nonRequiredFields = ['lastName']
 const { t } = useTranslation()
 const navigate = useNavigate()
 const isMobileView = useIsMobileView()
 const supportCallStatus = useSelector(getSupportCallStatus)

  if (supportCallStatus === 'loading') {
    return <LoadingSpinner />
  }

  const handleBlur = (field) => {
    if (!validFields[field].isValid || (!nonRequiredFields.includes(field) && userFields[field] === '')) {
      setValidation((prev) => ({
        ...prev,
        [field]: { 
          isValid: false,
          hasError: true 
        },
      }));
    }
  }

  const validateRegex = (field, newValue) => {
    const regexStrings = {
      email: /^(\S+@\S+\.\S+)$/
    }
    return regexStrings[field].test(newValue)
  }

  const handleChange = (e)=>{
    const {name, value} = e.target
    setUserFields(prev => ({
        ...prev,
        [name]: value
    }))

    if (nonRequiredFields.includes(name) && (!value || value.trim() === '')) {
      setValidation((prev) => ({
        ...prev,
        [name]: { 
          isValid: true,
          hasError: false },
      }));
      return
    }

    const regexFields = ['email']
    if (regexFields.includes(name)) {
      const regexIsValid = validateRegex(name, value)
      setValidation((prev) => ({
        ...prev,
        [name]: { 
          isValid: regexIsValid,
          hasError: !regexIsValid },
      }));
      return
    }

    if (value && value.trim() !== '') {
      setValidation((prev) => ({
        ...prev,
        [name]: { 
          isValid: true,
          hasError: false },
      }));
      return
    }

    
    setValidation((prev) => ({
      ...prev,
      [name]: { 
        isValid: false,
        hasError: true },
    }));

  }

  const handleSubmit = ()=>{
    dispatch(sendMail({
      firstName: userFields.firstName,
      lastName: userFields.lastName,
      email: userFields.email,
      body: userFields.message
    }))
  }

  const handleSendAnotherMessage = () => {
    dispatch(resetStatus())
    setUserFields({
        firstName: '',
        lastName: '',
        email: '',
        message: '',
    })
    setValidation({
        firstName: { isValid: false, hasError: false },
        lastName: { isValid: true, hasError: false },
        email: { isValid: false, hasError: false },
        message: { isValid: false, hasError: false },
    })
  }

  const closeError = () => {
    dispatch(resetStatus())
  }
  const isEmailError = validFields.email.hasError && !validFields.email.isValid

  return (
  <>
    <Grid className={isMobileView ? styles.containerFormMobile : styles.container}>
      <Link
        to="/"
        style={{
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                paddingTop: '29px',
                width:'fit-content',
              }}
        color="black"
      >
        <ArrowBackIcon
          sx={{
                  marginRight: '2px',
                  padding: '5px 0 0 0',
                  color: 'black',
                  transform: "translateX(-3px)",
                }}
        />
        <Typography
          variant="body2"
          sx={{
                  fontSize: '16px',
                  fontWeight: '400',
                  lineHeight: '23.2px',
                  padding: '5px 0 0 0',
                  color: 'black',
                }}
        >
          {t('user-profile-back')}
        </Typography>
      </Link>
      <h1 className={styles.contactHeader}>{ t('support-contact-support') }</h1>
          {supportCallStatus === 'failed' && (
            <div className={isMobileView ? styles['error-mobile-view'] : styles['error-view']}>
              <Alert
                className='errorAlertSupport'
                alertStyle="error-alert"
                headerText={t('support-error-header')}
                blurb={t('support-error-blurb')}
                onClose={closeError}
                showClose
                customStyles={{ backgroundColor: '#FDE3D7 !important' }}
              />
              </div>
          )}
          {supportCallStatus === 'succeeded' && (
            <div className={isMobileView ? styles['success-mobile-view'] : styles['success-view']}>
              <Alert
                className='successAlertSupport'
                alertStyle="success-alert"
                headerText={t('support-success-header')}
                blurb={t('support-success-blurb')}
                onClose={() => {}}
                showClose
                customStyles={{ backgroundColor: '#DDF5E4 !important' }}
              />
              <div className={styles['success-view-button']}>
                <Button
                  onClick={handleSendAnotherMessage}
                  className="secondary-btn"
                  variant="contained"
                  sx={{
                        backgroundColor: '#EB1700 !important',
                        color: 'white !important',
                        border: '1px solid #eb1700 !important',
                        width: 'auto !important',
                        minWidth: '120px !important',
                        borderRadius: '24px',
                        height: '40px',
                        marginLeft: '0px !important',
                        boxShadow: 'none'
                  }}
                >
                  {t('support-send-another')}
                </Button>
                
              </div>
            </div>
          )}
      {supportCallStatus !== 'succeeded' && (
          <>
      <Grid className={styles.formContainer}>

        <div onBlur={() => handleBlur('firstName')}>
        <TextInputField
          className={styles.supportInput}
          label={t('support-firstName')}
          required={true}
          id="firstName"
          name="firstName"
          value={userFields.firstName}
          onChange={handleChange}
          error={validFields.firstName.hasError && !validFields.firstName.isValid
                ?  t('label-mandatory-field')
                : "" }
          styles={{ width: '385px', marginTop: '22px', height: '81px' }}
        />
        </div>
        <TextInputField
          className={styles.supportInput}
          label={t('support-lastName')}
          required={false}
          id="lastName"
          name="lastName"
          value={userFields.lastName}
          onChange={handleChange}
          styles={{ width: '385px', marginTop: '22px', height: '81px' }}
          
        />
        <div onBlur={() => handleBlur('email')}>
        <TextInputField
          className={styles.supportInput}
          label={t('support-email')}
          required={true}
          id="email"
          name="email"
          value={userFields.email}
          onChange={handleChange}
          error={ isEmailError ? userFields.email === ''
                ?  t('label-mandatory-field')
                : t('validation-email')
                : ''
              }
          styles={{ width: '385px', marginTop: '22px', height: '81px' }}
        />
        </div>
        <div onBlur={() => handleBlur('message')}>
        <TextInputField
          className={styles.supportInput}
          label={t('support-message')}
          required={true}
          id="message"
          name="message"
          placeholder={ t('support-type-in-your-message') }
          value={userFields.message}
          onChange={handleChange}
          error={validFields.message.hasError && !validFields.message.isValid
                ?  t('label-mandatory-field')
                : "" }
          multiLine
          rows={6}
          styles={{ width: '385px', marginTop: '22px',
            "& textarea": {
                 resize: "vertical",
                 outline: 'none',
            }
           }}
          
          inputPlaceholder={styles.inputPlaceholder}
        />
        </div>

      </Grid>
      <Grid className={styles.buttonContainer}>
        <ButtonWithLoader
          className="primary-btn"
          label={ t('support-send-message') }
          disableElevation={true}
          onClick={handleSubmit}
          disabled={!isFormValid}
          sx={{
            backgroundColor: '#eb1700',
            width: '140px',
            height: '45px',
            '&:hover': {
              backgroundColor: '#CC1400',
            },
            '&:disabled': {
              backgroundColor: '#665A47',
            },
            '&:focus': {
              backgroundColor: '#CC1400',
            },
          }}
        />
        <Button
          onClick={()=> { navigate('/') }}
          type="submit"
          className="secondary-btn"
          variant="contained"
          disableElevation={true}
          sx={{
            marginLeft: '25px !important',
            color: '#000000',
            width: '128px',
            height: '45px',
            backgroundColor: 'rgba(98, 81, 55, 0.1)',
            '&:hover': {
              backgroundColor: 'rgba(102,90,71, 0.20)',
            },
            '&:disabled': {
              backgroundColor: 'rgba(138, 115, 92, 0.05)',
            },
            '&:focus': {
              backgroundColor: 'rgba(112, 99, 79, 0.1)',
            },
          }}
        >
          {t('create-support-button-cancle')}
        </Button>
      </Grid>
      </>)}
    </Grid>
  </>
  )
}

export default SupportForm
